<template>
  <div>
    <v-dialog
      lazy
      scrollable
      persistent
      :value="show"
      :fullscreen="$vuetify.breakpoint.xs"
      :width="1280"
      @input="(v) => $emit('update:show', v)"
    >
      <v-card class="menu-how-to-stepper-dialog-card">
        <v-card-text class="pa-0">
          <menu-how-to-stepper
            :step-index.sync="currentStepIndex"
            show-initial-step
            :show-progressbar="!lastStepReached"
            :show-back-button="false"
          />
          <v-slide-y-transition>
            <v-layout
              v-if="lastStepReached"
              justify-center
              class="my-3"
            >
              <v-btn
                round
                large
                color="msr"
                dark
                data-cy="menu-how-to-stepper-dialog-start-btn"
                style="min-width: 320px"
                :to="{name: 'menuitems', params: {menuId: menuId}}"
              >
                {{ $t('menuHowToStepperStartNowButton') }}
              </v-btn>
            </v-layout>
          </v-slide-y-transition>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {HOW_TO_STEPS} from '@/components/Menu/MenuHowToStepper';
import MenuHowToStepper from '@/components/Menu/MenuHowToStepper';

export default {
  components: {
    MenuHowToStepper,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      currentStepIndex: 1, // Note: Must start at 1, v-stepper can't handle a 0.
    };
  },
  computed: {
    numSteps() {
      return HOW_TO_STEPS.length;
    },
    lastStepReached() {
      return this.currentStepIndex == this.numSteps;
    },
    menuId() {
      return this.$route.params.menuId;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },
  },
};
</script>

<style>
/* Make backdrop darker to better focus on the dialog. */
.v-dialog__content--active:has(.menu-how-to-stepper-dialog-card)
  + .v-overlay--active:before {
  opacity: 0.86 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu/MenuHowToStepperDialog.vue